// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"4ba0f40d","247":"bdc98def","422":"57c1d54e","627":"4657624b","768":"3c17ef20","834":"74279ad9","867":"3585f994","923":"ea772dfb","938":"fb7cfd01"}[chunkId] + ".chunk.js";
};